export default "__VITE_ASSET__OU3S1zgQ__"